import { Box, Text } from "@chakra-ui/react";
import React, { useEffect, useRef } from "react";
import SkillCard from "./SkillCard";
import SectionTitle from "../Common/SectionTitle";
import { useNavigate } from "react-router-dom";
const Skills = () => {
  const navigate = useNavigate();
  const frontendBoxRef = useRef(null);
  const backendBoxRef = useRef(null);
  useEffect(() => {
    if (frontendBoxRef.current) {
      const timer = setTimeout(() => {
        const canvas = frontendBoxRef.current.getElementsByTagName("canvas");
        if (canvas.length > 1) {
          canvas[1].remove();
        }
      }, [2000]);
      return () => clearTimeout(timer);
    }
  }, [frontendBoxRef]);
  useEffect(() => {
    if (backendBoxRef.current) {
      const timer = setTimeout(() => {
        const canvas = backendBoxRef.current.getElementsByTagName("canvas");
        canvas[1].remove();
      }, [2000]);
      return () => clearTimeout(timer);
    }
  }, [backendBoxRef]);
  return (
    <Box>
      <SectionTitle title="Toolbox of Talent" />
      <Box
        display="grid"
        gridTemplateColumns={{
          base: "repeat(1,minmax(100px,1fr))",
          smm: "repeat(2,minmax(100px,1fr))",
          lg: "repeat(3,minmax(100px,1fr))",
        }}
        gridGap={16}
        alignItems="center"
        justifyContent="space-between"
        mb="3rem"
      >
        {/* for frontend */}
        <SkillCard
          title="Frontend"
          text1={"ReactJs | NextJs     ReactJs | NextJs"}
          text2={"Angular            Angular"}
        />
        {/* for backend */}
        <SkillCard
          title="Backend"
          text1={"NodeJs     |    NodeJs"}
          text2={".NET Core      |      .NET Core"}
        />
        {/* for database */}
        <SkillCard
          title="Database"
          text1={"Firebase  |   SQL"}
          text2={"Mongo DB"}
        />

        <SkillCard
          title="Languages"
          text1={"Javascript   |  HTML  |  CSS  | SCSS"}
          text2={"C+ |   C++   |   C#"}
        />
        <SkillCard title="Frameworks" text1={".NET MAUI | .NET WPF"} />
        <SkillCard title="Animations" text1={"Processing | p5.Js"} />
        <SkillCard title="Cloud" text1={"Google Cloud [ GCP ]  |  Docker"} />
      </Box>
    </Box>
  );
};

export default Skills;
